import styled, { css } from "styled-components"

export const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Wrapper = styled.div`
  min-height: 530px;
  width: 83.3%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const StyledFlatList = styled.div`
  ${props =>
    props.displayType === "grid"
      ? css`
          padding-bottom: 200px;
          width: 100%;
          display: grid;
          row-gap: 27px;
          grid-template-columns: repeat(auto-fill, minmax(320px, 0.8fr));
          justify-content: flex-start;
          column-gap: 20px;

          @media (max-width: 1149px) {
            justify-content: center;
            column-gap: 30px;
          }

          @media (max-width: 850px) {
            column-gap: 10px;
          }
        `
      : css`
          width: 100%;
          display: flex;
          gap: 0px;
          flex-direction: column;
          align-items: center;
          padding-bottom: 200px;
        `}
`

export const PageBar = styled.div`
  height: 156px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const PageBox = styled.div`
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Page = styled.div`
  height: 60px;
  width: 65px;
  border-radius: 2px;
  background: #111111;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    color: #fdfdfd;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
  }
`

export const LastPage = styled(Page)`
  background: inherit;
`
